<template>
  <div>
    <label class="label">หัวข้อ</label>
    <el-input class="mb-3" type="text" v-model="title"></el-input>
    <div class="phone-group" v-for="(group, index) in sections" :key="index">
      <div class="text-right">
        <sc-button
          v-if="!disabled"
          variant="danger"
          class="btn-delete"
          @click="handleClickRemoveGroup(index)"
        >ลบกลุ่ม</sc-button>
      </div>
      <div class="row">
        <div class="col-9">
          <label class="label">ชื่อกลุ่ม</label>
          <el-input
            class="mb-3"
            type="text"
            :value="group.title"
            @input="handleInputGroup(index, $event)"
          ></el-input>
        </div>
      </div>
      <div
        class="row mb-4 input"
        v-for="(input, inputIndex) in group.inputs"
        :key="`${index}-${inputIndex}`"
      >
        <div class="col-2">
          <label class="label">หัวข้อ</label>
          <el-input
            type="text"
            :value="input.title"
            @input="handleInputInput(index, inputIndex, 'title', $event)"
          ></el-input>
        </div>
        <div class="col-2">
          <label class="label">ประเภท</label>
          <el-select
            :value="input.type"
            :disabled="disabled"
            @input="handleInputInput(index, inputIndex, 'type', $event)"
          >
            <el-option
              v-for="extra in extraTypeOptions"
              :value="extra.value"
              :key="extra.value"
              :label="extra.label"
            >{{ extra.label }}</el-option>
          </el-select>
        </div>
        <div class="col-2" v-show="!isCitizenCardImage(input.type)">
          <label class="label">Prefill</label>
          <el-select
            :value="input.prefillKey"
            :disabled="disabled"
            @input="handleInputInput(index, inputIndex, 'prefillKey', $event)"
            placeholder="ไม่ Prefill"
            clearable
          >
            <el-option
              v-for="extra in extraPrefillOptions"
              :value="extra.value"
              :key="extra.value"
              :label="extra.label"
            >{{ extra.label }}</el-option>
          </el-select>
        </div>
        <div class="col-2" v-show="isCitizenCardImage(input.type)">
          <sc-button
            v-if="!disabled"
            class="watermark-button"
            @click="handleClickChooseWatermarkImage(index, inputIndex, input.watermarkUrl, input.watermarkFile)"
          >{{ watermarkButtonName(input.watermarkUrl) }}</sc-button>
        </div>
        <div class="col-1">
          <el-checkbox
            class="required-checkbox"
            :disabled="disabled"
            :value="input.isRequired"
            @input="handleInputInput(index, inputIndex, 'isRequired', $event)"
          >จำเป็นต้องกรอก</el-checkbox>
        </div>
        <div class="col-2 text-right">
          <sc-button
            v-if="!disabled"
            variant="danger"
            class="btn-delete"
            @click="handleClickRemoveInput(index, inputIndex)"
          >ลบ</sc-button>
        </div>
      </div>
      <div class="row" v-if="!disabled">
        <div class="offset-4 col-5">
          <sc-button class="w-100" @click="handleClickAddInput(index)">เพิ่ม</sc-button>
        </div>
      </div>
    </div>
    <div class="row mt-4" v-if="!disabled">
      <div class="col-6 offset-3">
        <sc-button class="w-100" variant="secondary" @click="handleClickAddGroup">เพิ่มกลุ่ม</sc-button>
      </div>
    </div>
    <image-picker-modal
      v-bind="chooseWatermarkImageDialog"
      @cancel="handleCancelChooseWatermarkImage"
      @confirm="handleConfirmChooseWatermarkImage('watermarkFile', $event)"
    ></image-picker-modal>
  </div>
</template>

<script>
import ScButton from "@/lib/components/ScButton";
import { Input, Select, Option, Checkbox } from "element-ui";
import ImagePickerModal from "@/lib/components/ImagePickerModal";
import { isNil, isEmpty } from "ramda";

export default {
  components: {
    ScButton,
    ElInput: Input,
    ImagePickerModal,
    "el-select": Select,
    "el-option": Option,
    "el-checkbox": Checkbox
  },
  props: ["value", "disabled"],
  data() {
    const extraTypeOptions = [
      { value: "TEXT", label: "ข้อความ" },
      { value: "LONG_TEXT", label: "ข้อความยาว" },
      { value: "CITIZEN_CARD_IMAGE", label: "รูปบัตรประชาชน" }
    ];

    const extraPrefillOptions = [
      { value: "NAME", label: "ชื่อ" },
      { value: "MOBILE_NUMBER", label: "เบอร์โทรศัพท์" }
    ];

    return {
      extraPrefillOptions,
      extraTypeOptions,
      isShowWatermarkImageDialog: false,
      watermarkImage: {
        file: null,
        url: null,
        groupIndex: null,
        inputIndex: null
      }
    };
  },
  computed: {
    title: {
      get() {
        return this.value.title;
      },
      set(title) {
        this.$emit("input", { ...this.value, title });
      }
    },
    sections() {
      return this.value.sections;
    },
    chooseWatermarkImageDialog() {
      return {
        isShow: this.isShowWatermarkImageDialog,
        isLoading: false,
        canEdit: true,
        title: "เลือกรูปภาพลายน้ำบัตรประชาชน",
        width: 800,
        height: 500,
        // TODO: remove ENV check when ready to production
        accept: process.env.DEPLOY_ENV !== "production" ? "image/png" : null,
        message: process.env.DEPLOY_ENV !== "production" ? "เป็นไฟล์สกุล png เท่านั้น" : null,
        recommendWidth: 800,
        recommendHeight: 500,
        thumbnailFile: this.watermarkImage.file,
        thumbnailUrl: this.watermarkImage.url
      };
    }
  },
  methods: {
    watermarkButtonName(watermarkUrl) {
      return isNil(watermarkUrl) ? "เพิ่มลายน้ำ" : "แก้ไขลายน้ำ"
    },
    handleClickRemoveGroup(index) {
      this.$emit("input", {
        ...this.value,
        sections: this.value.sections.filter((_, i) => index !== i)
      });
    },
    handleClickRemoveInput(groupIndex, inputIndex) {
      this.$emit("input", {
        ...this.value,
        sections: this.value.sections.map((group, i) =>
          i === groupIndex
            ? {
                ...group,
                inputs: group.inputs.filter((_, ci) => ci !== inputIndex)
              }
            : group
        )
      });
    },
    handleClickAddInput(groupIndex, inputIndex) {
      this.$emit("input", {
        ...this.value,
        sections: this.value.sections.map((group, index) =>
          groupIndex === index
            ? {
                ...group,
                inputs: [
                  ...group.inputs,
                  {
                    title: null,
                    type: "",
                    prefillKey: null,
                    isRequired: false,
                    watermarkUrl: null,
                    watermarkFile: null
                  }
                ]
              }
            : group
        )
      });
    },
    handleClickChooseWatermarkImage(groupIndex, inputIndex, watermarkUrl, watermarkFile) {
      this.watermarkImage.url = watermarkUrl ? watermarkUrl : null
      this.watermarkImage.file = watermarkFile ? watermarkFile : null;
      this.watermarkImage.groupIndex = groupIndex;
      this.watermarkImage.inputIndex = inputIndex;
      this.isShowWatermarkImageDialog = true;
    },
    handleConfirmChooseWatermarkImage(name, event) {
      this.$emit("input", {
        ...this.value,
        sections: this.value.sections.map((group, index) =>
          this.watermarkImage.groupIndex === index
            ? {
                ...group,
                inputs: group.inputs.map((input, cIndex) =>
                  cIndex === this.watermarkImage.inputIndex ? { ...input, [name]: event } : input
                )
              }
            : group
        )
      });

      this.isShowWatermarkImageDialog = false;
    },
    handleCancelChooseWatermarkImage() {
      this.isShowWatermarkImageDialog = false;
    },
    handleClickAddGroup() {
      this.$emit("input", {
        ...this.value,
        sections: [...this.value.sections, { title: "", inputs: [] }]
      });
    },
    handleInputGroup(index, event) {
      this.$emit("input", {
        ...this.value,
        sections: this.value.sections.map((group, i) =>
          i === index ? { ...group, title: event } : group
        )
      });
    },
    handleInputInput(groupIndex, inputIndex, name, event) {
      this.$emit("input", {
        ...this.value,
        sections: this.value.sections.map((group, index) =>
          groupIndex === index
            ? {
                ...group,
                inputs: group.inputs.map((input, cIndex) =>
                  cIndex === inputIndex ? { ...input, [name]: event } : input
                )
              }
            : group
        )
      });
    },
    isCitizenCardImage(type) {
      return type === "CITIZEN_CARD_IMAGE";
    }
  }
};
</script>

<style lang="scss" scoped>
.input .btn-delete {
  margin-top: 33px;
}

.input .watermark-button {
  display: block;
  width: 100%;
  margin-top: 33px;
}

.phone-group {
  padding: 30px;

  &:nth-child(2n) {
    background: #ddd;
  }
}

.required-checkbox {
  margin-top: 41px;
}
</style>




// WEBPACK FOOTER //
// src/features/subscriptions/modules/packages/components/PackageExtraEditor.vue